export enum CustomerTypeEnum {
  UnRegistered = 0, //Easy reservation or walk in
  Registered = 1, // Registered customer with password
  UnregisteredStore = 2, // Registered customer without password from store
  UnregisteredHQ = 3  // // Registered customer without password from HQ
}
  